/*
  This example requires some changes to your config:

  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ],
  }
  ```
*/
import {
    Combobox,
    ComboboxButton,
    ComboboxInput,
    ComboboxOption,
    ComboboxOptions,
    Label,
} from '@headlessui/react';
import { ChevronUpDownIcon } from '@heroicons/react/20/solid';
import { useState } from 'react';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
}

const MyCombobox = ({
    options,
    value,
    onChange,
    className,
    optionsClassName,
    noTruncate,
    filter,
    onlyShowSearchResults,
}) => {
    const [query, setQuery] = useState('');
    const selected = (options.filter(opt => opt.key === value) || [null])[0];

    function setSelected(opt) {
        onChange(opt?.key);
    }

    let filteredOptions =
        query === ''
            ? (onlyShowSearchResults ? [] : options)
            : options.filter(opt => {
                  if (typeof filter === 'function') {
                      return filter(opt.label, query);
                  } else {
                      if (typeof opt.label.toLowerCase === 'function') {
                          return opt.label
                              .toLowerCase()
                              .includes(query.toLowerCase());
                      } else {
                          return opt.key
                              .toLowerCase()
                              .includes(query.toLowerCase());
                      }
                  }
              });
    // Max # of items for rendering performance. It's unmanageable without this anyway.
    filteredOptions = filteredOptions.slice(0, 200);

    return (
        <Combobox
            as="div"
            value={selected}
            onChange={item => {
                setQuery('');
                setSelected(item);
            }}
        >
            <div className={`relative ${className}`}>
                <ComboboxInput
                    className="w-full rounded-md border-0 bg-white py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:!ring-1 focus:ring-inset sm:text-sm sm:leading-6"
                    onChange={event => setQuery(event.target.value)}
                    onBlur={() => setQuery('')}
                    placeholder={onlyShowSearchResults ? "Type to search..." : ''}
                    displayValue={person =>
                        typeof person?.label === 'object'
                            ? person?.key
                            : person?.label
                    }
                />
                <ComboboxButton className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
                    <ChevronUpDownIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                    />
                </ComboboxButton>

                {filteredOptions.length > 0 && (
                    <ComboboxOptions
                        className={`absolute z-10 mt-1 max-h-60 w-64 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm ${optionsClassName}`}
                    >
                        {filteredOptions.map(person => (
                            <ComboboxOption
                                key={person.key}
                                value={person}
                                className={({ focus }) =>
                                    classNames(
                                        'relative cursor-default select-none py-2 pl-3 pr-9',
                                        focus ? 'bg-gray-100' : 'text-gray-900',
                                    )
                                }
                            >
                                {({ focus, selected }) => (
                                    <>
                                        <span
                                            className={classNames(
                                                `block ${!noTruncate ? 'truncate' : ''}`,
                                            )}
                                        >
                                            {person.label}
                                            {!!person.description && (
                                                <span className="ml-2 text-gray-500">
                                                    {person.description}
                                                </span>
                                            )}
                                        </span>
                                    </>
                                )}
                            </ComboboxOption>
                        ))}
                    </ComboboxOptions>
                )}
            </div>
        </Combobox>
    );
};

export default MyCombobox;
